import { useContext } from 'react';

import { QContentContext } from './qcontent-provider';

function useQContent() {
  const context = useContext(QContentContext);

  if (!context) {
    throw new Error('useQContent must be used within a QContentProvider');
  }

  return context;
}

export { useQContent };
